export const ERROR_DUPLICATE_PROFILE = 'DUPLICATE_PROFILE';
export const ERROR_DEFAULT = 'default';
export const ERROR_HOST_NOT_FOUND = 'HOST_NOT_FOUND';
export const ERROR_BAD_INTEGRATION_CONFIGURATION = 'BAD_INTEGRATION_CONFIGURATION';
